<app-content>
  <app-breadcrumbs>
    <li>
      <a routerLink='/e-uslugi' aria-label='E-usługi'>E-usługi</a>
    </li>
    <li>
      {{ serviceType()?.name || 'Ładowanie danych...' }}
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      {{ serviceType()?.name || '' }}
    </h2>
    @if (!pending() && !loading()) {
      <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="row">
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"origin" as controlName'>
              <label [for]='controlName'>
                Miejsce wyjazdu *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu miejsce wyjazdu'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"destination" as controlName'>
              <label [for]='controlName'>
                Miejsce docelowe podróży *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu miejsce docelowe podróży'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        </div>
        <fieldset>
          <legend>
            Zakres danych
          </legend>
          <br>
          <div class="row">
            <div class="col-md-6">
              <div class="row">
                <div class="col-12">
                  <div class='form-group' *ngIf='"extreme" as controlName'>
                    <div class='custom-checkbox custom-inline'
                         [ngClass]='{ "is-invalid": form.showError(controlName) }'>
                      <input
                        [formControlName]='controlName'
                        type='checkbox'
                        [id]='controlName'
                        [name]='controlName'>
                      <label [for]='controlName'>
                        Skrajnie
                      </label>
                    </div>
                    <app-validation-errors [control]='form.get(controlName)'>
                    </app-validation-errors>
                  </div>
                </div>
                <div class="col-12">
                  <div class='form-group' *ngIf='"allowableLoads" as controlName'>
                    <div class='custom-checkbox custom-inline'
                         [ngClass]='{ "is-invalid": form.showError(controlName) }'>
                      <input
                        [formControlName]='controlName'
                        type='checkbox'
                        [id]='controlName'
                        [name]='controlName'>
                      <label [for]='controlName'>
                        Dopuszczalne obciążenia
                      </label>
                    </div>
                    <app-validation-errors [control]='form.get(controlName)'>
                    </app-validation-errors>
                  </div>
                </div>
                <div class="col-12">
                  <div class='form-group' *ngIf='"constructionsOrRepairs" as controlName'>
                    <div class='custom-checkbox custom-inline'
                         [ngClass]='{ "is-invalid": form.showError(controlName) }'>
                      <input
                        [formControlName]='controlName'
                        type='checkbox'
                        [id]='controlName'
                        [name]='controlName'>
                      <label [for]='controlName'>
                        Prowadzone inwestycje/remonty
                      </label>
                    </div>
                    <app-validation-errors [control]='form.get(controlName)'>
                    </app-validation-errors>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-12">
                  <div class='form-group' *ngIf='"maintenanceWorks" as controlName'>
                    <div class='custom-checkbox custom-inline'
                         [ngClass]='{ "is-invalid": form.showError(controlName) }'>
                      <input
                        [formControlName]='controlName'
                        type='checkbox'
                        [id]='controlName'
                        [name]='controlName'>
                      <label [for]='controlName'>
                        Prace utrzymaniowe
                      </label>
                    </div>
                    <app-validation-errors [control]='form.get(controlName)'>
                    </app-validation-errors>
                  </div>
                </div>
                <div class="col-12">
                  <div class='form-group' *ngIf='"weatherConditions" as controlName'>
                    <div class='custom-checkbox custom-inline'
                         [ngClass]='{ "is-invalid": form.showError(controlName) }'>
                      <input
                        [formControlName]='controlName'
                        type='checkbox'
                        [id]='controlName'
                        [name]='controlName'>
                      <label [for]='controlName'>
                        Warunki pogodowe
                      </label>
                    </div>
                    <app-validation-errors [control]='form.get(controlName)'>
                    </app-validation-errors>
                  </div>
                </div>
                <div class="col-12">
                  <div class='form-group' *ngIf='"cameras" as controlName'>
                    <div class='custom-checkbox custom-inline'
                         [ngClass]='{ "is-invalid": form.showError(controlName) }'>
                      <input
                        [formControlName]='controlName'
                        type='checkbox'
                        [id]='controlName'
                        [name]='controlName'>
                      <label [for]='controlName'>
                        Kamery
                      </label>
                    </div>
                    <app-validation-errors [control]='form.get(controlName)'>
                    </app-validation-errors>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset>
          <legend>
            Narysuj przebieg interesującej Cię trasy
          </legend>
          <br>
          <div class="row">
            <div class="col-12">
              <app-exposed-map-control [alertMessage]="null" [control]="form.geometry">
              </app-exposed-map-control>
            </div>
          </div>
        </fieldset>
        <div class='application-actions'>
          <button
            routerLink="../"
            type='button'
            class='btn btn-secondary'>
        <span>
          Wstecz
        </span>
          </button>
          <button
            type='submit'
            class='btn btn-primary'>
            <span>Pobierz dane</span>
          </button>
        </div>
      </form>
    } @else {
      <app-spinner>
        {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
      </app-spinner>
    }
  </section>
</app-content>
